<template>
  <div class="flex flex-col py-16 px-8" data-test="sidepanel-toolbar" role="tablist">
    <ToolbarButton v-for="[index, button] of buttons.entries()" :key="button.group"
      :activeGroupRef="props.activeGroupRef"
      :icon="button.icon"
      :index="index"
      :group="button.group"
      :onClick="button.onClick"
      :onIconLoad="button.onIconLoad"
      :requires="button.requires"
      :title="button.title"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import ToolbarButton from '@/io.ox/core/sidepanel/toolbar-button.vue'
import upsell from '@/io.ox/core/upsell'

const buttons = ref([])

const props = defineProps({
  activeGroupRef: { type: Object, required: true }
})

function addButton ({ group, icon, index = 100, onClick, onIconLoad, requires, title } = {}) {
  if (requires && !upsell.available(requires)) return
  buttons.value.push({ group, icon, index, onClick, onIconLoad, requires, title })
  buttons.value.sort((a, b) => a.index - b.index)
}

defineExpose({ addButton })

</script>
